// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"0f9810ac","378":"f1a8d020","803":"0f9810ac","897":"f1a8d020"}[chunkId] + ".chunk.css";
};